import {
  TAGS_LIST_REQ,
  TAGS_LIST_SET,
  TAGS_LIST_SUCCESS,
  TAGS_LIST_ERROR,
  TAGS_CREATE_REQ,
  TAGS_CREATE_SET,
  TAGS_CREATE_SUCCESS,
  TAGS_CREATE_ERROR,
  TAGS_UPDATE_REQ,
  TAGS_UPDATE_SET,
  TAGS_UPDATE_SUCCESS,
  TAGS_UPDATE_ERROR,
  TAGS_DELETE_REQ,
  TAGS_DELETE_SET,
  TAGS_DELETE_SUCCESS,
  TAGS_DELETE_ERROR
} from './tags.type'

import ApiRest from '@/api/api-rest'

const state = {
  fetchLocationTagsReqStatus: '',
  locationTags: []
}

const getters = {
  fetchLocationTagsReqStatus: state => state.fetchLocationTagsReqStatus,
  locationTags: state => state.locationTags
}

// Best Practice - updates state
const mutations = {
  [TAGS_LIST_SET]: (state, data) => {
    state.locationTags = _.map(data, tag => {
      return _.merge(tag, { name: tag.tag, active: false, editFlag: false })
    })
  },
  [TAGS_LIST_REQ]: state => {
    state.fetchLocationTagsReqStatus = 'loading'
  },
  [TAGS_LIST_SUCCESS]: (state, data) => {
    state.fetchLocationTagsReqStatus = 'saved'
  },
  [TAGS_LIST_ERROR]: (state, errMsg) => {
    state.fetchLocationTagsReqStatus = 'error'
  },
  [TAGS_CREATE_SET]: (state, tags) => {
    state.locationTags.push(tags)
  },
  [TAGS_CREATE_REQ]: state => {
    state.fetchLocationTagsReqStatus = 'loading'
  },
  [TAGS_CREATE_SUCCESS]: (state, data) => {
    state.fetchLocationTagsReqStatus = 'saved'
  },
  [TAGS_CREATE_ERROR]: (state, errMsg) => {
    state.fetchLocationTagsReqStatus = 'error'
  },
  [TAGS_UPDATE_SET]: (state, tags) => {
    let findTag = _.find(state.locationTags, { id: tags.id })
    if (findTag) {
      findTag.tag = tags.tag
    }
  },
  [TAGS_UPDATE_REQ]: state => {
    state.fetchLocationTagsReqStatus = 'loading'
  },
  [TAGS_UPDATE_SUCCESS]: (state, data) => {
    state.fetchLocationTagsReqStatus = 'saved'
  },
  [TAGS_UPDATE_ERROR]: (state, errMsg) => {
    state.fetchLocationTagsReqStatus = 'error'
  },
  [TAGS_DELETE_SET]: (state, tags) => {
    tags.forEach(tag => {
      let findTagIndex = _.findIndex(state.locationTags, { id: tag.id })
      if (findTagIndex > -1) {
        state.locationTags.splice(findTagIndex, 1)
      }
    })
  },
  [TAGS_DELETE_REQ]: state => {
    state.fetchLocationTagsReqStatus = 'loading'
  },
  [TAGS_DELETE_SUCCESS]: (state, data) => {
    state.fetchLocationTagsReqStatus = 'saved'
  },
  [TAGS_DELETE_ERROR]: (state, errMsg) => {
    state.fetchLocationTagsReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [TAGS_LIST_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      context.commit(TAGS_LIST_REQ)
      ApiRest()
        .get('tags/location')
        .then(({ data }) => {
          context.commit(TAGS_LIST_SET, data)
          context.commit(TAGS_LIST_SUCCESS)
          resolve(data)
        })
    })
  },
  [TAGS_CREATE_REQ] (context, tags) {
    return new Promise((resolve, reject) => {
      let endpoint = `/tags/${tags.type}`
      context.commit(TAGS_CREATE_REQ)
      ApiRest()
        .post(endpoint, { tag: tags.tag.name })
        .then(({ data }) => {
          context.commit(TAGS_CREATE_SET, _.merge(tags.tag, { id: data.id }))
          context.commit(TAGS_LIST_SUCCESS)
          resolve(data)
        })
    })
  },
  [TAGS_UPDATE_REQ] (context, tags) {
    return new Promise((resolve, reject) => {
      let endpoint = `/tags/${tags.type}`
      context.commit(TAGS_CREATE_REQ)
      ApiRest()
        .put(endpoint, { id: tags.id, oldtag: tags.oldtag, tag: tags.tag })
        .then(({ data }) => {
          context.commit(TAGS_UPDATE_SET, { id: tags.id, oldtag: tags.oldtag, tag: tags.tag })
          context.commit(TAGS_LIST_SUCCESS)
          resolve(data)
        })
    })
  },
  [TAGS_DELETE_REQ] (context, tags) {
    return new Promise((resolve, reject) => {
      let endpoint = `/tags/bulkdel/${tags.type}`
      context.commit(TAGS_DELETE_REQ)
      ApiRest()
        .post(endpoint, { tags: tags.tags })
        .then(({ data }) => {
          context.commit(TAGS_DELETE_SET, tags.tags)
          context.commit(TAGS_LIST_SUCCESS)
          resolve(data)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tags/tags.module.js